import { inject } from '@angular/core';
import { NgDestroyed } from '@floori-web-components';
import { Store } from '@ngrx/store';

export abstract class BaseFacade extends NgDestroyed {
    protected store = inject(Store);
}
